import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { QuestionnaireForm } from './QuestionnaireForm';
import {
  QuestionnaireAnswers,
  QuestionnaireFormBuilder,
  QuestionnaireFormBuilderProps,
} from '../QuestionnaireFormBuilder';
import { Suggestion, SuggestionDropDown } from '../../forms/SuggestionDropDown';
import styled from 'styled-components';
import { FlexboxVertical } from '../../Layout';
import { MinimalUser } from '../../../../interfaces/User';
import * as AuthStore from '../../../store/AuthStore';
import { QuestionnaireWithResultSets } from '../../../../interfaces/Questionnaire';
import { useApiDispatchQueue } from '../../../../state/ApiDispatchState';
import * as MinimalUsersCache from '../../../store/MinimalUsersCache';

const UserSelectionWrapper = styled(FlexboxVertical)`
  margin-top: -5rem;    // remove questionnaire bottom margin
  margin-bottom: 3rem;
`;

interface Props extends Omit<QuestionnaireFormBuilderProps, 'answersState' | 'questionnaireId' | 'questions'> {
  selectedUserState: [MinimalUser, Dispatch<SetStateAction<MinimalUser>>];
  answersState: [{ [questionnaireId: string]: QuestionnaireAnswers }, Dispatch<SetStateAction<{ [questionnaireId: string]: QuestionnaireAnswers }>>];
  allQuestionnaires?: Array<QuestionnaireWithResultSets | null>;
}
export const QuestionnaireLeadQuestions: FC<Props> = ({ selectedUserState, ...props }) => {
  const { answersState, allQuestionnaires } = props;
  const [users, setUsers] = useState<MinimalUser[] | null>(MinimalUsersCache.get());
  const [selection, setSelection] = selectedUserState;
  const dispatchApiCall = useApiDispatchQueue();

  const parseSuggestion = (user: MinimalUser | null) => {
    if (!user) {
      return null;
    }

    return {
      id: user.id,
      text: `${user.familyName}, ${user.firstName} (${user.email})`,
    } as Suggestion;
  };

  useEffect(() => {
    dispatchApiCall({
      method: 'get',
      route: '/api/users/min',
      header: AuthStore.getAuthHeader(),
      onSuccess: (res) => {
        setUsers(res.data);
        MinimalUsersCache.set(res.data as MinimalUser[]);
      },
    });
  }, []);

  return (
    <QuestionnaireForm title={'Lead generieren'}>

      {
        (allQuestionnaires || []).map((questionnaire, index) => (
          <QuestionnaireFormBuilder
            {...props}
            key={index}
            answersState={[((answersState[0] || {})[questionnaire.id] || {}), (value) => {
              answersState[1]({
                ...answersState[0],
                [questionnaire.id]: (value || {}) as QuestionnaireAnswers,
              });
            }]}
            questionnaireId={questionnaire.id}
            questions={questionnaire.questionnaire.questions}
          />
        ))
      }

      <UserSelectionWrapper>
        <SuggestionDropDown
          id={'select_lead_user'}
          onChange={(suggestion) => setSelection(users.find(({ id }) => id === suggestion.id))}
          value={parseSuggestion(selection)}
          suggestions={(users || []).map(parseSuggestion)}
          label={'Lead versenden an:'}
          inline={false}
          hasError={props.showErrorStates && !Boolean(selection)}
        />
      </UserSelectionWrapper>

    </QuestionnaireForm>
  )
}
